export const stripUrlProtocol = (url: string): string =>
  url.replace(/^\s*https?:\/\//i, '')
